import React from "react";
import ZoomableDivWrapperTable from "../components/TableSummaryDashboard/ZoomableTableWrapper"
import TableSummaryDashboard from "../components/TableSummaryDashboard";

const DashboardTablePage = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  // Capture the initial height before any keyboard opens so the table container
  // never collapses when the Flutter WebView resizes due to keyboard show/hide.
  const [pageHeight] = React.useState(() => window.innerHeight);

  React.useEffect(() => {
    // Prevent iOS WKWebView from auto-zooming when an editable cell is focused.
    // ZoomableTableWrapper already handles pinch-to-zoom via CSS zoom + touch events,
    // so disabling native browser scaling here does not break the custom zoom.
    const viewport = document.querySelector('meta[name="viewport"]');
    if (!viewport) return;
    const original = viewport.getAttribute('content') ?? '';
    viewport.setAttribute(
      'content',
      'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, shrink-to-fit=no'
    );
    return () => {
      viewport.setAttribute('content', original);
    };
  }, []);

  return (
    <div style={{ height: pageHeight, overflow: 'hidden' }}>
      <ZoomableDivWrapperTable initialScale={0.5} minScale={0.2} maxScale={1.5} isLoading={isLoading}>
        <TableSummaryDashboard setLoadingMobile={setIsLoading} />
      </ZoomableDivWrapperTable>
    </div>
  )
}

export default DashboardTablePage
